import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext(null);

function getStoredMode() {
  try {
    const saved = localStorage.getItem("stems_theme");
    if (saved === "light" || saved === "dark" || saved === "system") return saved;
  } catch {}
  return "light";
}
function systemPrefersDark() {
  return typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(prefers-color-scheme: dark)").matches
    : false;
}

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(getStoredMode);
  const [systemDark, setSystemDark] = useState(systemPrefersDark);

  // Track OS preference so "system" mode stays live.
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = (e) => setSystemDark(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const theme = mode === "system" ? (systemDark ? "dark" : "light") : mode;

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
  }, [theme]);

  const setMode = useCallback((m) => {
    setModeState(m);
    try { localStorage.setItem("stems_theme", m); } catch {}
  }, []);

  const toggleTheme = useCallback(() => setMode(theme === "dark" ? "light" : "dark"), [theme, setMode]);

  return (
    <ThemeContext.Provider value={{ theme, mode, setMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
